import React, { useMemo } from 'react'
import { allowedFlags } from 'core/widgets/CountriesDropdown/allowed-flags'

const localeToFlag = (locale: string) => {
  const code = locale.toLowerCase().split('-')?.[1] || ''
  if (allowedFlags.indexOf(code) > -1) {
    // The flag emoji is a combination of the two unicode region characters,
    // We take the letters, add it to the char code index at the start of the flags region 127397
    // For CH(Switzerland), we want the indexes to be 127464 and 127469.
    // Then we map it back to a string.
    return String.fromCodePoint(
      ...code
        .toUpperCase()
        .split('')
        .map(char => 127397 + char.charCodeAt(0))
    )
  }

  return null
}

export const LocaleFlag: React.FC<{ locale: string }> = ({ locale }) => {
  const flag = useMemo(() => localeToFlag(locale), [locale])

  return <span className='emoji-flag'>{flag || '\u00A0'}</span>
}
